/**
 * Circular dependancy resolution file
 * Here we force the order of includes
 */

import "../../../vendor/bower-asset/jquery/dist/jquery.min.js";
import "../jquery/jquery.noconflict.js";

import "./egw.js";
import "./egw_core.js";
import "./egw_debug.js";
import "./egw_preferences.js";
import "./egw_lang.js";
import "./egw_links.js";
import "./egw_open.js";
import "./egw_user.js";
import "./egw_config.js";
import "./egw_images.js";
import "./egw_jsonq.js";
import "./egw_files.js";
import "./egw_json.js";
import "./egw_store.js";
import "./egw_tooltip.js";
import "./egw_css.js";
import "./egw_calendar.js";
import "./egw_ready.js";
import "./egw_data.js";
import "./egw_tail.js";
import "./egw_inheritance.js";
import "./egw_message.js";
import "./egw_notification.js";
import "./egw_timer.js";
import "./jsapi.js";